export default {
  // DepartmentInformation
  departmentName: '부서명',
  departmentCode: '부서코드',
  temporary: '임시영역',
  state: '적용상태',
  departmentAdd: '부서 추가',
  selectDelete: '선택 삭제',
  modifyBtn: '수정',
  title: '부서 추가',
  title2: '부서 정보 삭제',
  updateTitle: '부서 수정',
  deleteMsg: '선택하신 항목을 삭제하시겠습니까?',
  alertMsg: '삭제할 항목을 선택해 주세요.',
  modificationDate: '수정일시',
  createMsg: '부서 정보가 등록되었습니다.',
  updateMsg: '부서 정보가 수정되었습니다.',
  deleteMessage: '부서 정보가 삭제되었습니다.',
  validationContentNull: '부서정보를 입력해주세요.',
  validationContentLength: '부서정보의 길이는 최대 100자 입니다.',
};
